import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { generateReceipt } from "../../utils/receiptGenerator";
import "../../assets/styles/studentpayment.css";

function StudentPayments() {
  const navigate = useNavigate();
  const [payments, setPayments] = useState([]);

  useEffect(() => {
    const studentId = localStorage.getItem("studentId");

    fetch(`https://shuttle-craft-student-transport.onrender.com/api/payments/student/${studentId}`)
      .then((res) => res.json())
      .then((data) => {
        setPayments(data);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <div className="payments-container">
      <h2>My Payments</h2>

      <button className="pay-btn" onClick={() => navigate("/pay-fees")}>
        Pay Monthly Fees
      </button>
      <div className="table-wrapper">
        <table className="payments-table">
          <thead>
            <tr>
              <th>Invoice</th>
              <th>Amount</th>
              <th>Mode</th>
              <th>Date</th>
              <th>Receipt</th>
            </tr>
          </thead>

          <tbody>
            {payments.map((p) => (
              <tr key={p._id}>
                <td>{p.invoice}</td>

                <td className="amount">₹{p.amount}</td>

                <td>{p.paymentMode}</td>

                <td>{new Date(p.date).toLocaleDateString()}</td>

                <td>
                  <button
                    className="download-btn"
                    onClick={() => generateReceipt(p)}
                  >
                    Download
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default StudentPayments;
